import { Icon } from "./Icon.tsx";

/** "Lasso select" tool icon — a freehand dashed loop. */
export function SelectLassoIcon() {
  return (
    <Icon>
      <path
        d="M12 4c-5 0-8 3.2-8 6.8 0 3 2.6 5.2 6 5.2 1 0 1.6.6 1.4 1.6-.2 1-1.2 1.4-2 1"
        strokeDasharray="3 2.5"
      />
      <circle cx="17" cy="9.5" r="1.4" fill="currentColor" stroke="none" />
    </Icon>
  );
}
